import { useState } from 'react';
import { validateBillDate, validateDepartmentId, validateSubTotal, validateSubtotalAndAdvancePayment, validateUploadDocuments } from '../utils/helpers/globalValidation';
import { validateGSTFields, validateTaxEditFields } from '../utils/helpers/globalValidation';
import { MIN_QUANTITY_ERROR } from '../utils/helpers/globalErrorMessage';

const EditBillValidation = () => {
  const [errors, setErrors] = useState({});

  const validateForm = (BillDate, isAdvancePayment, advancePayment, lineGSTcheck, Files, Cgst, Sgst, UTgst, Igst, Tax, InvoiceTotal, subsidiaryId, selectedFiles, lineItems, roleId, departmentId, contractStartDate, contractEndDate, billEndDate) => {

    let formIsValid = true;
    let errors = {};

    const billDateError = validateBillDate(BillDate, contractStartDate, contractEndDate, billEndDate);
    if (billDateError) {
      formIsValid = false;
      errors.billDate = billDateError;
    }


    // const subtotalError = validateSubTotal(InvoiceTotal);
    // if (subtotalError) {
    //   formIsValid = false;
    //   errors.subtotal = subtotalError;
    // }

    const {
      formIsValid: subtotalFormIsValid,
      errors: subtotalErrors,
    } = validateSubtotalAndAdvancePayment({
      isAdvancePayment,
      advancePayment,
      InvoiceTotal,
    });

    formIsValid = formIsValid && subtotalFormIsValid;
    errors = { ...errors, ...subtotalErrors };

    const departmentError = validateDepartmentId(roleId, departmentId);
    if (departmentError) {
      formIsValid = false;
      errors.departmentId = departmentError;
    }

    if (!lineGSTcheck) {
      const { formIsValid: gstFormIsValid, errors: gstErrors } = validateGSTFields({ cgst: Cgst, sgst: Sgst, utgst: UTgst, igst: Igst }, subsidiaryId);
      formIsValid = formIsValid && gstFormIsValid;
      errors = { ...errors, ...gstErrors };
      const zeroQuantityLines = lineItems.filter((item) => {
        return (
          (item.Quantity <= 0 || item.Quantity === '')
        );
      });
      if (zeroQuantityLines.length > 0) {
        alert(MIN_QUANTITY_ERROR)
        return;
      }
    } else {
      const { formIsValid: gstFormIsValid, errors: gstErrors } = validateTaxEditFields(lineGSTcheck, isAdvancePayment, Cgst, Sgst, UTgst, Igst, Tax, subsidiaryId, lineItems);
      formIsValid = formIsValid && gstFormIsValid;
      errors = { ...errors, ...gstErrors };
    }

    const documentError = validateUploadDocuments(Files, selectedFiles);
    formIsValid = formIsValid && documentError.formIsValid;
    errors.files = documentError.errors.files;

    setErrors(errors);
    return formIsValid;
  };

  return { errors, setErrors, validateForm };
};

export default EditBillValidation;



// import { useState } from 'react';
// import { ADMIN_MANAGER_ID } from '../utils/constant';

// const EditBillValidation = () => {
//   const [errors, setErrors] = useState({});

//   const isValidFileType = (file) => {
//     const allowedTypes = ["application/pdf"];
//     return allowedTypes.includes(file.type);
//   };

//   const MAX_FILE_SIZE = 2 * 1024 * 1024;

//   const validateForm = (BillDate, isAdvancePayment, advancePayment, lineGSTcheck, Files, Cgst, Sgst, UTgst, Igst, Tax, InvoiceTotal, subsidiaryId, selectedFiles, lineItems, roleId, departmentId) => {

//     let errors = {};
//     let formIsValid = true;

//     if (!BillDate) {
//       formIsValid = false;
//       errors.billDate = "Select Bill Date"
//     }

//     // if (!isAdvancePayment && parseFloat(InvoiceTotal) === 0) {
//     //   formIsValid = false;
//     //   errors.subtotal = "Subtotal can't be zero !";
//     // }

//     // if (isAdvancePayment && advancePayment === "") {
//     //   formIsValid = false;
//     //   errors.advancePayment = "Subtotal is required.";
//     // }

//     // if (isAdvancePayment && advancePayment === "0") {
//     //   formIsValid = false;
//     //   errors.advancePayment = "Subtotal cannot be zero!";
//     // }

//     if (!advancePayment && InvoiceTotal === "0.00") {
//       formIsValid = false;
//       errors.subtotal = "Subtotal cannot be zero !";
//     }

//     if (isAdvancePayment && advancePayment === "") {
//       formIsValid = false;
//       errors.advancePayment = "Advance Total is required.";
//     }

//     if (isAdvancePayment && advancePayment === "0") {
//       formIsValid = false;
//       errors.advancePayment = "Advance Total cannot be zero!";
//     }

//     if (!lineGSTcheck && !isAdvancePayment) {
//       if (!Cgst && !Sgst && !UTgst && !Igst && subsidiaryId === 2) {
//         formIsValid = false;
//         errors.taxError = "One of the GST Field is required !";
//       }
//       else if (Cgst && !Sgst) {
//         formIsValid = false;
//         errors.taxError = "Enter SGST";
//       }
//       else if (!Cgst && Sgst) {
//         formIsValid = false;
//         errors.taxError = "Enter CGST";
//       }
//       if (!Tax && subsidiaryId === 1) {
//         formIsValid = false;
//         errors.taxError = "Sales Tax is required !";
//       }
//       const zeroQuantityLines = lineItems.filter((item) => {
//         return (
//           (item.Quantity <= 0 || item.Quantity === '')
//         );
//       });
//       if (zeroQuantityLines.length > 0) {
//         alert("Quantity can't be zero")
//         return;
//       }
//     }
//     else {

//       const missingQuantityLines = lineItems.filter((item) => {
//         return (
//           (item.Quantity < 0 || item.Quantity === '') && (item.CGST || item.SGST || item.UTGST || item.IGST)
//         );
//       });

//       const missingGstLines = lineItems.filter((item) => {
//         return (
//           (item.Quantity > 0) &&
//           (item.CGST === null || item.CGST === '') &&
//           (item.SGST === null || item.SGST === '') &&
//           (item.UTGST === null || item.UTGST === '') &&
//           (item.IGST === null || item.IGST === '')
//         );
//       });

//       if (!isAdvancePayment) {
//         if (missingGstLines) {
//           formIsValid = false;
//           errors.gstError = "One of the GST field is required if quantity is there";
//         } else if (missingQuantityLines) {
//           formIsValid = false;
//           errors.quantityError = "Quantity is required if any GST field is there";
//         }
//       }

//       const zeroQuantityLines = lineItems.filter((item) => {
//         return (
//           (item.Quantity <= 0 || item.Quantity === '')
//         );
//       });

//       const cgstAndSgstValidation = lineItems.filter((item) => {
//         return (
//           ((item.CGST === null || item.CGST === '') && item.SGST) ||
//           ((item.SGST === null || item.SGST === '') && item.CGST)
//         );
//       });

//       if (missingGstLines.length > 0) {
//         alert('One of the GST field is required if quantity is there');
//         return;
//       }
//       else if (missingQuantityLines.length > 0) {
//         alert('Quantity is required if any GST field is there');
//         return;
//       }
//       else if (isAdvancePayment.length > 0 && zeroQuantityLines.length > 0) {
//         alert("Quantity can't be zero")
//         return;
//       }
//       else if (cgstAndSgstValidation.length > 0) {
//         alert('Enter both CGST and SGST if one is there');
//         return;
//       }
//     }

//     if (Files.length === 0) {
//       if (selectedFiles.length === 0) {
//         formIsValid = false;
//         errors.files = "Please upload a document !";
//       }
//       else {
//         for (const item of selectedFiles) {
//           if (!isValidFileType(item)) {
//             formIsValid = false;
//             errors.files = "Only PDF is allowed !";
//             break;
//           }
//           if (item.size > MAX_FILE_SIZE) {
//             formIsValid = false;
//             errors.files = "Maximum allowed file size is 2MB !";
//             break;
//           }
//           if (selectedFiles.length > 5) {
//             formIsValid = false;
//             errors.files = "Only 5 files are allowed !";
//             break;
//           }
//         }
//       }
//     }
//     else {
//       for (const item of selectedFiles) {
//         if (!isValidFileType(item)) {
//           formIsValid = false;
//           errors.files = "Only PDF is allowed !";
//           break;
//         }
//         if (item.size > MAX_FILE_SIZE) {
//           formIsValid = false;
//           errors.files = "Maximum allowed file size is 2MB !";
//           break;
//         }
//         if (selectedFiles.length + Files.length > 5) {
//           formIsValid = false;
//           errors.files = "Only 5 files are allowed !";
//           break;
//         }
//       }
//     }

//     if (roleId === ADMIN_MANAGER_ID) {
//       if (!departmentId) {
//         formIsValid = false;
//         errors.departmentId = "Select Department";
//       }
//     }

//     setErrors(errors);
//     return formIsValid;
//   };

//   return { errors, setErrors, validateForm };
// };

// export default EditBillValidation;
